<template>
  <div class="term-wrapper">
    <el-row type="flex" justify="left">
      <span class="label">{{ title }}</span>
    </el-row>
    <el-row type="flex" :justify="align" class="desc">
      <slot></slot>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "" },
    align: { type: String, default: "left" }
  }
};
</script>

<style scoped>
.term-wrapper {
  padding: 10px 15px;
}
.label {
  font-size: 16px;
  font-weight: bold;
  color: rgb(34, 34, 34);
}
.desc {
  color: #666;
  line-height: 1.5;
  font-size: 15px;
}
</style>
